<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
            <!-- <ion-button>
              <ion-icon slot="icon-only" name="menu"></ion-icon>
            </ion-button> -->
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="back">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <ion-grid>
        <ion-row class="row-boxed mt-20 text-left">
          <ion-col class="text-left" size="12" size-md="6">
            <ion-button @click="openFilter" expand="block" color="secondary"><span class="btn-left text-lower">Filters</span></ion-button>
          </ion-col>
          <!--<ion-col class="text-left" size="12" size-md="4">-->
          <!--  <ion-button @click="openOrder" expand="block" color="secondary"><span class="btn-left text-lower">Order</span></ion-button>-->
          <!--</ion-col>-->
          <ion-col class="text-left" size="12" size-md="6">
            <ion-button @click="preExportPdf" expand="block" color="secondary"><span class="btn-left text-lower">Export PDF</span></ion-button>
          </ion-col>
        </ion-row>
        <ion-row class="row-boxed mt-20">
          <ion-col size="12">
            <div class="title text-left block mb-10">{{ report.name }}</div>
            <div class="fix-pl-50">
              <report-worklist-index :allowedWorklists="allowedWorklists" @worklistsDetails="(idx) => worklistsDetails(idx)" :worklists="worklists"></report-worklist-index>
            </div>
          </ion-col>
        </ion-row>

      </ion-grid>

      <modal-export
        v-if="modalExport"
        @close="modalExport = 0"
        @submit="exportPdf"
      ></modal-export>

      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
import Vue from "vue"
// import PopoverFilters from "./partials/PopoverFilters"
// import PopoverOrders from "./partials/PopoverOrders"
import ReportWorklistIndex from "./partials/ReportWorklistIndex";
import PopoverFiltersWorklist from "./partials/PopoverFiltersWorklist";
import ModalExport from "./partials/ModalExport";
export default {
  name: "YachtReport",
  components: {
    ModalExport,
    'report-worklist-index': ReportWorklistIndex
  },
  computed: {
    // allowedColors: function() {
    //   let allowed = []
    //   for (const k in this.filtersColor) {
    //     if (Object.hasOwnProperty.call(this.filtersColor, k)) {
    //       const value = this.filtersColor[k];
    //       if(value) {
    //         allowed.push(k)
    //       }
    //     }
    //   }
    //   return allowed
    // },
    allowedWorklists: function() {
      let allowed = []
      for (const k in this.filtersRef) {
        if (Object.hasOwnProperty.call(this.filtersRef, k)) {
          const value = this.filtersRef[k];
          if(value) {
            allowed.push(k)
          }
        }
      }
      return allowed
    },
  },
  data: function() {
    return {
      worklists: [],
      worklists_orig: [],
      report: {},
      loader: true,
      // filtersColor: {
      //   red: true,
      //   green: true,
      //   yellow: true,
      //   nocolor: true,
      // },
      filtersRef: {},
      order: 'ref_number',
      orderType: 'asc',
      divHeight: 0,
      pdf: '',
      modalExport: false
    }
  },
  methods: {
    preExportPdf: function() {
      this.modalExport = true
    },
    exportPdf: function(data) {
      let allowed = btoa(JSON.stringify(this.allowedWorklists))
      window.open(this.apiUrl + '/worklist-pdf?id=' + this.$route.params.id + '&allowed=' + allowed +  '&data=' + data, '_blank')
    },
    back: function() {
      this.$router.push('/worklist/report/'+this.report.yacht_id)
    },
    worklistsDetails: async function(wl) {
      this.$router.push({name: 'compile-worklist', params: { id: wl.id } });
    },
    worklistsItemDetails: async function(wl, i) {
      this.$router.push({name: 'compile-worklist-index', params: { id: wl.id, index: i } });
    },
    openFilter: async function(ev){
      const popover = await this.$ionic.popoverController.create({
        component: PopoverFiltersWorklist,
        event: ev,
        translucent: true,
        componentProps: {
          propsData: {
            filtersRef: this.filtersRef
          },
        },
      });

      await popover.present();
      let res = await popover.onDidDismiss();
      if(res && res.data) {
        this.filtersRef = res.data.filtersRef
      }
    },
    orderWorklists: function() {
      this.loader = true
      Vue.set(this, 'worklists', []);
      this.getWorkListReports()
      this.loader = false
    },
    // openOrder: async function(ev){
    //   console.log(ev)
      // const popover = await this.$ionic.popoverController.create({
      //   component: PopoverOrders,
      //   event: ev,
      //   translucent: true,
      //   componentProps: {
      //     propsData: {
      //       order: this.order,
      //       orderType: this.orderType,
      //     },
      //   },
      // });
      //
      // await popover.present();
      // let res = await popover.onDidDismiss();
      // if(res && res.data) {
      //   let change = false
      //   if(this.order != res.data.order) {
      //     this.order = res.data.order
      //     change = true
      //   }
      //   if(this.orderType != res.data.orderType) {
      //     this.orderType = res.data.orderType
      //     change = true
      //   }
      //   if(change) {
      //     this.orderWorklists()
      //   }
      // }
    // },
    getWorkListReports: async function() {
      await axios.post(this.apiUrl + '/api/v1/get-worklists', { api_token: this.$store.state.api_token, id: this.$route.params.id, order: { type: this.orderType, val: this.order } })
        .then((response) => {
          let res = response.data
          if(res.data.length) {
            let i = 0
            while (i < res.data.length) {
              Vue.set(this.worklists, this.worklists.length, res.data[i]);
              Vue.set(this.worklists_orig, this.worklists_orig.length, res.data[i]);
              // if (!res.data[i].parent == 0) {
                Vue.set(this.filtersRef, res.data[i].ref_number, true);
              // }
              i++
            }
          }
        })
    },

  },
  mounted: async function() {
    await this.getWorkListReports()

    await axios.post(this.apiUrl + '/api/v1/get-worklist', { api_token: this.$store.state.api_token, id: this.$route.params.id })
      .then((response) => {
        let res = response.data
        if(res.data) {
          this.report = res.data
        }
      })
    this.loader = false;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
